/**
 * Recent nav destinations for the ⌘K palette (epic #897 PR 2, ported
 * from ops-console). Stored as a small JSON array of nav paths in
 * localStorage — most recent first, deduped, capped. Storage failures
 * (private mode, quota) are swallowed: recents are a convenience,
 * never a dependency.
 */
const STORAGE_KEY = 'console.recent-paths';
const MAX_ENTRIES = 8;

export function loadRecentPaths(): readonly string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((entry): entry is string => typeof entry === 'string');
  } catch {
    return [];
  }
}

export function pushRecentPath(path: string): void {
  try {
    const next = [path, ...loadRecentPaths().filter((entry) => entry !== path)].slice(
      0,
      MAX_ENTRIES,
    );
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Best-effort only.
  }
}
